import * as React from 'react';
import { Icon } from 'antd';
import { Button, Separator } from '@ui/components';

interface Props {
  noCollections: number;
  yesCollections: number;
  allCollections: number;
  onSetStatusToWholeCollection: () => void;
  onSave: () => void;
  disableSendRequest: boolean;
  historyCollections: any[];
}

const CollectionPanel: React.FunctionComponent<Props> = ({
  noCollections,
  yesCollections,
  onSetStatusToWholeCollection,
  onSave,
  disableSendRequest,
  historyCollections,
}) => {
  const allHistoryCollections = historyCollections.length;
  const yesHistoryCollections = historyCollections.filter(({ status }) => status).length;
  const hasHistoryCollections = allHistoryCollections - yesHistoryCollections;

  return (
    <div className="store-page__collections__panel">
      <div className="store-page__collections__panel__count">
        Коллекция:{' '}
        <span style={{ color: hasHistoryCollections ? 'red' : 'black' }}>
          {yesHistoryCollections} / {allHistoryCollections}
        </span>
      </div>
      <div className="store-page__collections__panel__info-panel">
        <div className="store-page__collections__panel__info">
          <div className="store-page__collections__yes">
            <Icon type="check" style={{ color: 'green' }} />
            <span>{yesCollections}</span>
          </div>
          <Separator />
          <div className="store-page__collections__no">
            <Icon type="close" style={{ color: 'red' }} />
            <span>{noCollections}</span>
          </div>
        </div>
        <Button className="select-all-button" onClick={onSetStatusToWholeCollection}>
          <Icon type="check" style={{ color: 'green' }} />
          Выделить ВСЕ
        </Button>
        <Button onClick={onSave} disable={disableSendRequest} className="store-page__collections__panel__button">
          <Icon type="arrow-right" />
          Отправить
        </Button>
      </div>
    </div>
  );
};

export default CollectionPanel;



// WEBPACK FOOTER //
// ./src/scenes/Store/components/CollectionPanel/CollectionPanel.tsx